import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { AutocompleteService } from '@apply4u/services/autocomplete.service';
import { AutoComplete, RecentSearchesAutoComplete } from '@apply4u/models/autocomplete';
import { LocalstorageService } from '@apply4u/services/localstorage.service';
import { KeyboardEvents } from '@apply4u/shared/constant/keyboard-event.constant';
import { IsAny, IsNotNull, IsNotNullOrEmpty, IsNullOrEmpty } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { ContextService } from '@apply4u/services/context-service';
import { UserDirectoryKeys } from '@apply4u/shared/constant/Local-storage-keys/user-directory';
import { SearchService } from '@apply4u/services/search/search.service';

@Component({
  selector: 'app-keyword-autocomplete',
  templateUrl: './keyword-autocomplete.component.html',
  styleUrls: ['./keyword-autocomplete.component.css']
})
export class KeywordAutocompleteComponent {
  SearchTerm: any = "";
  IsSuggestRecentSearch: boolean = false;
  IsSuggestAutoCompleteSearch: boolean = false;
  DisplaySuggestedSector: AutoComplete[] = [];
  ArrowkeySuggestedSearch: number = -1;
  ArrowkeySuggestedRecentSearch: number = -1;
  RecentSearchesAutoComplete: RecentSearchesAutoComplete[] = [];
  KeywordSelectedOption: AutoComplete = new AutoComplete();
  
  @Input() Classes:string;
  @Input() SearchKeywordTitle: string;
  @Input() HideRecentSearches: boolean = false;
  @Input() Placeholder: string = 'By Job title or keyword e.g. "Warehouse"';
  @Input() IsAdvanceSearchPage: boolean = false;
  
  @Output() OnInput: EventEmitter<string> = new EventEmitter<string>();
  @Output() SearchKeywordTitleChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() OnSelectionChanged: EventEmitter<AutoComplete> = new EventEmitter<AutoComplete>();
  @Output() OnSelectedOption: EventEmitter<AutoComplete> = new EventEmitter<AutoComplete>();
  @Output() IsEnterKeyPressed: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private autoCompleteService: AutocompleteService,
    private _elementRef: ElementRef,
    private localStorageService: LocalstorageService,
    private contextService: ContextService,
    private searchService: SearchService,) {}

  OnInputRecentSearch(event: any) : void {
    if (event.target.value.length > 0) {
      this.SearchTerm = event.target.value;
      var result;
      this.autoCompleteService.getSectorsAutoComplete(this.SearchTerm, false, true).subscribe(searchWordResult => {
        if (IsAny(searchWordResult)) {
          this.SetStatusKeywordAutoComplete(searchWordResult);
        }
      });
    } else {
      this.IsSuggestRecentSearch = false;
      this.ArrowkeySuggestedRecentSearch = -1;
      this.ArrowkeySuggestedSearch = -1;
      this.DisplaySuggestedSector = [];
    }

    this.OnInput.emit(this.SearchKeywordTitle);
  }

  SetStatusKeywordAutoComplete(result: any) : void {
    if (IsAny(result)) {
      this.DisplaySuggestedSector = [];
      this.IsSuggestAutoCompleteSearch = true;
      this.IsSuggestRecentSearch = false;
      this.ArrowkeySuggestedRecentSearch = -1;
      this.ArrowkeySuggestedSearch = -1;
      this.DisplaySuggestedSector = result;
    }
  }
  OnkeyDownSearch(event: any) : void {
    if (event.keyCode === KeyboardEvents.ArrowDownKey) {
      if (this.IsSuggestAutoCompleteSearch == true) {
        if (this.ArrowkeySuggestedSearch < this.DisplaySuggestedSector.length - 1) {
          this.ArrowkeySuggestedSearch++;
                  } else {
          this.ArrowkeySuggestedSearch = -1;
        }

        let option = this.DisplaySuggestedSector[this.ArrowkeySuggestedSearch];
        this.KeywordSelectedOption = option;
        this.SearchKeywordTitle = option.Value;
        this.SearchKeywordTitleChanged.emit(this.SearchKeywordTitle);
      } else if (this.IsSuggestRecentSearch == true) {
        if (this.ArrowkeySuggestedRecentSearch < this.RecentSearchesAutoComplete.length - 1) {
          this.ArrowkeySuggestedRecentSearch++;
          } else {
          this.ArrowkeySuggestedRecentSearch = -1;
        }

        let option = this.RecentSearchesAutoComplete[this.ArrowkeySuggestedRecentSearch];
        this.KeywordSelectedOption.Value = option.Title;
        this.KeywordSelectedOption.Key = option.Id.toString();
        this.SearchKeywordTitle = option.Title;
        this.SearchKeywordTitleChanged.emit(this.SearchKeywordTitle);
      }
    } else if (event.keyCode === KeyboardEvents.ArrowUpKey) {
      if (this.IsSuggestAutoCompleteSearch == true) {
        if (this.ArrowkeySuggestedSearch > 0) {
          this.ArrowkeySuggestedSearch--;
          } else {
          this.ArrowkeySuggestedSearch = this.DisplaySuggestedSector.length - 1;
        }

        let option = this.DisplaySuggestedSector[this.ArrowkeySuggestedSearch];
        this.KeywordSelectedOption = option;
        this.SearchKeywordTitle = option.Value;
        this.SearchKeywordTitleChanged.emit(this.SearchKeywordTitle);
      } else if (this.IsSuggestRecentSearch == true) {
        if (this.ArrowkeySuggestedRecentSearch > 0) {
          this.ArrowkeySuggestedRecentSearch--;
          } else {
          this.ArrowkeySuggestedRecentSearch = this.RecentSearchesAutoComplete.length - 1;
        }

        let option = this.RecentSearchesAutoComplete[this.ArrowkeySuggestedRecentSearch];
        this.KeywordSelectedOption.Value = option.Title;
        this.KeywordSelectedOption.Key = option.Id.toString();
        this.SearchKeywordTitle = option.Title;
        this.SearchKeywordTitleChanged.emit(this.SearchKeywordTitle);
      }
    }
    else if (event.keyCode === KeyboardEvents.EnterKey) {
      if (IsNotNull(this.KeywordSelectedOption) && IsNotNullOrEmpty(this.KeywordSelectedOption.Key)) {
        if (this.IsSuggestAutoCompleteSearch == true) {
          let option = this.DisplaySuggestedSector[this.ArrowkeySuggestedSearch];
          this.OnSearchOptionSelected(option);
          this.ArrowkeySuggestedSearch = 0;
           } else if (this.IsSuggestRecentSearch == true) {
          let option = this.RecentSearchesAutoComplete[this.ArrowkeySuggestedRecentSearch];
           this.OnSearchRecentOptionSelected(option);
          this.ArrowkeySuggestedRecentSearch = -1;
          this.EmitEnterKeyPressedEvent();
        } else {
          this.EmitEnterKeyPressedEvent();
          }
      } else {
        this.EmitEnterKeyPressedEvent();
       }
    }
  }

  EmitEnterKeyPressedEvent() : void {
    this.IsSuggestRecentSearch = false;
    this.IsSuggestAutoCompleteSearch = false;
    this.SearchKeywordTitleChanged.emit(this.SearchKeywordTitle);
    this.IsEnterKeyPressed.emit(true);
  }

  OnSearchOptionSelected(option: AutoComplete) : void {
    this.IsSuggestRecentSearch = false;
    this.IsSuggestAutoCompleteSearch = false;

    if (IsNotNull(option)) {
      this.SearchKeywordTitle = option.Value;
      this.SearchKeywordTitleChanged.emit(this.SearchKeywordTitle);
      this.KeywordSelectedOption = option;
      this.OnSelectedOption.emit(option);
      this.DisplaySuggestedSector = [];
      this.ArrowkeySuggestedRecentSearch = -1;
      this.ArrowkeySuggestedSearch = -1;
    }
  }

  OnSearchRecentOptionSelected(option: RecentSearchesAutoComplete, isClicked : boolean = false) : void {
    this.IsSuggestRecentSearch = false;
    this.IsSuggestAutoCompleteSearch = false;
    
    if (IsNotNull(option)) {
      this.SearchKeywordTitle = option.Title;
      this.SearchKeywordTitleChanged.emit(this.SearchKeywordTitle);
      this.KeywordSelectedOption.Value = option.Title;
      this.KeywordSelectedOption.Key = option.Id.toString();
      this.OnSelectedOption.emit(this.KeywordSelectedOption);
      this.DisplaySuggestedSector = [];
      this.ArrowkeySuggestedRecentSearch = -1;
      this.ArrowkeySuggestedSearch = -1;
    }    

    if (isClicked && IsNotNull(option.RecentSearchParams)) {
      this.searchService.SearchParams = option.RecentSearchParams;
      this.EmitEnterKeyPressedEvent();
    }
  }

  DisplayRecentSearches($event: Event) : void {
    if (IsNullOrEmpty(this.SearchKeywordTitle)) {
      this.IsSuggestRecentSearch = true;
      this.IsSuggestAutoCompleteSearch = false;
      let recentSearches = this.localStorageService.GetItem(UserDirectoryKeys.RecentSearches);
      this.RecentSearchesAutoComplete = JSON.parse(recentSearches);

      if (IsAny(this.RecentSearchesAutoComplete)) {
        if (this.contextService.IsJobSeeker) {
          this.RecentSearchesAutoComplete = this.RecentSearchesAutoComplete.filter((v, i) => (v.SearchType == "Jobs") && v.Title != "" &&
          this.RecentSearchesAutoComplete.findIndex(item => item.Title.toLowerCase().trim() == v.Title.toLowerCase().trim()) === i);
        } else {
          this.RecentSearchesAutoComplete = this.RecentSearchesAutoComplete.filter((v, i) => (v.SearchType == "CVs") && v.Title != "" &&
          this.RecentSearchesAutoComplete.findIndex(item => item.Title.toLowerCase().trim() == v.Title.toLowerCase().trim()) === i);
        }
      }
    } else {
      this.IsSuggestRecentSearch = false;
      this.IsSuggestAutoCompleteSearch = true;
    }
  }

  OnkeyUpSearch(event: any) : void {
    if (IsNullOrEmpty(this.SearchKeywordTitle)) {
      this.IsSuggestRecentSearch = true;
      this.IsSuggestAutoCompleteSearch = false;
    }
  }

  onFocusoutSearch() : void {
    this.IsSuggestRecentSearch = false;
    this.IsSuggestAutoCompleteSearch = false;
  }

  OnSearchKeywordChange() : void {
    this.KeywordSelectedOption.Value = this.SearchKeywordTitle;
    this.OnSelectionChanged.emit(this.KeywordSelectedOption);
    this.SearchKeywordTitleChanged.emit(this.SearchKeywordTitle);
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) : void {
    const isClickedInside = this._elementRef.nativeElement.contains(targetElement);

    if (!isClickedInside) {
      this.IsSuggestRecentSearch = false;
      this.IsSuggestAutoCompleteSearch = false;
      this.ArrowkeySuggestedRecentSearch = -1;
      this.ArrowkeySuggestedSearch = -1;
    }
  }

}
